import { PDFDocument } from "../types";
import { colors, margin } from "../constants";
import autoTable from "jspdf-autotable";
import { KulionerOrder, KulionerProduct } from "@/domain/entities/Kulioner";
import { ellipsisString } from "@/app/infrastructures/misc/Utils";

const preloadImages = async (data: KulionerOrder): Promise<void> => {
  await Promise.all(
    data.koProduct.map((product: KulionerProduct) =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = resolve;
        img.onerror = reject;
        img.src = product.kodProductThumbnail;
      }).catch((error) => console.log(`Failed to preload image: ${error}`))
    )
  );
};

const renderImage = (doc: PDFDocument, table: any, product: string) => {
  const imageWidth = 7;
  const maxHeight = 7;
  const imageType = product.toLowerCase().endsWith(".png") ? "PNG" : "JPEG";

  try {
    const properties = doc.getImageProperties(product);
    let imageHeight = imageWidth * (properties.height / properties.width);
    let finalWidth = imageWidth;

    if (imageHeight > maxHeight) {
      imageHeight = maxHeight;
      finalWidth = maxHeight / (properties.height / properties.width);
    }

    const yOffset = (table.cell.height - imageHeight) / 2;
    const xOffset = (table.cell.width - finalWidth) / 2;

    doc.addImage(
      product,
      imageType,
      table.cell.x + xOffset,
      table.cell.y + yOffset,
      finalWidth,
      imageHeight,
      `prod-img-${table.row.index}`,
      "FAST"
    );
  } catch (error) {
    console.log(`Failed to render image: ${error}`);
  }
};

export const renderTable = async (
  doc: PDFDocument,
  startYTable: number,
  data: KulionerOrder,
  onDrawPage: () => void
): Promise<void> => {
  await preloadImages(data);

  autoTable(doc, {
    theme: "plain",
    body: data.koProduct.map((product, index) => [
      index + 1,
      { content: ellipsisString(product.kodProductName, 100) },
      product.kodQuantity
    ]),
    columnStyles: {
      0: { cellWidth: 7 },
      1: { fontStyle: "semibold" },
      2: { cellWidth: 13 }
    },
    styles: {
      font: "helvetica",
      fontSize: 6,
      textColor: colors.primary,
      valign: "middle",
      halign: "left",
      minCellHeight: 9.1
    },
    headStyles: {
      fillColor: colors.tableHeader,
      fontSize: 6,
      fontStyle: "medium",
      textColor: colors.secondary,
      minCellHeight: 5
    },
    startY: startYTable,
    pageBreak: "auto",
    margin,
    head: [["No", "Produk", "Kuantitas"]],
    didDrawPage: onDrawPage,
    willDrawCell: (table: any) => {
      if (table.section === "body") {
        // not render image coz CORS issue
        // if (table.column.index === 1) {
        //   renderImage(
        //     doc,
        //     table,
        //     data.koProduct[table.row.index].kodProductThumbnail
        //   );
        // }
        if (table.row.index === data.koProduct.length - 1) {
          // draw dash line for last row
          doc.setLineDashPattern([1,1], 20)
        }
        doc.line(
          table.cell.x,
          table.cell.y + table.cell.height,
          table.cell.x + table.cell.width,
          table.cell.y + table.cell.height
        );
        doc.setDrawColor(colors.border);
        doc.setLineDashPattern([], 0)
      }
    }
  });
};
